// Revenu net imposable (Revenu annuel net après abattement et déductions)

const computeNetIncomes = (rip, { deductions, incomes }) => {
    const netIncomes = incomes - deductions;

    return { netIncomes };
};

export default computeNetIncomes;
